import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useSettingsStore } from '@/store/modules/settings';

import { inject } from 'vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const $pub = inject('$pub');
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const refreshRoute = () => {
      $pub('reload-router-view');
    };
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      return _unref(theme).showRefresh ? (_openBlock(), _createBlock(_component_vab_icon, {
        key: 0,
        icon: "refresh-line",
        onClick: refreshRoute
      })) : _createCommentVNode("", true);
    };
  }
});